export default class SecondBoard {
  secondBoardCopy?: boolean;
  secondBoardConfiguration?: string;
  secondBoardPlacementInfo?: string;
}
